import Tooltip from "@material-ui/core/Tooltip";
// helpers
import { copyTextToClipboard } from "helpers";
import React from "react";

export default function CopyLabel({ label }) {
  const [hover, setHover] = React.useState(false);
  const [click, setClick] = React.useState(false);

  return (
    <Tooltip title={click ? "Copied!" : "Click to Copy"}>
      <span
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setClick(true);
          copyTextToClipboard(label);
        }}
        style={{
          background: hover ? "rgba(155,155,155, 0.1)" : "rgba(33,150,243, 0)",
          cursor: "pointer",
        }}
      >
        {label}
      </span>
    </Tooltip>
  );
}
